import { Accordion, Stack } from 'react-bootstrap';
import { useEffect, useState } from 'react';

import Common from '../../stores/Common';
import { IAnnouncementModel } from '../../interfaces/IAnnoucementModel';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { ToggleIcon } from '../../shared/ToggleIcon';

interface IAnnouncementAccordionProps {
    announcement: IAnnouncementModel;
    activeKeys: string[];
    setActiveKeys: React.Dispatch<React.SetStateAction<string[]>>;
}

export function AnnouncementAccordion({
    announcement,
    activeKeys,
    setActiveKeys,
}: IAnnouncementAccordionProps) {
    const isOpen = activeKeys.includes(announcement.guid);

    const handleToggleClick = () => {
        if (isOpen) {
            const filteredKeys = activeKeys.filter((key) => key !== announcement.guid);
            setActiveKeys(filteredKeys);
            return;
        }

        setActiveKeys([...activeKeys, announcement.guid]);
    };

    const announcementUrl = LocalRoutes.Announcement.replace(
        ':announcementContentGuid',
        announcement?.guid || ''
    );

    return (
        <Accordion.Item
            eventKey={announcement.guid}
            key={announcement.guid}
            style={{ borderBottom: '1px solid #c7c7c7' }}
        >
            <Accordion.Header>
                <Stack direction="horizontal" gap={2} style={{ alignItems: 'center' }}>
                    <span className="">
                        <ToggleIcon isOpen={isOpen} onClick={handleToggleClick} />
                    </span>
                    {announcement.icon && (
                        <i className={announcement.icon} style={{ cursor: 'default' }}></i>
                    )}
                    <span style={{ opacity: 0.7 }}>
                        {Common.dateTimeFormat(announcement.effectiveDate)}
                    </span>
                    {announcement?.title}
                </Stack>
            </Accordion.Header>
            <Accordion.Body>
                <Stack gap={2}>
                    <div>{announcement.text}</div>
                    {announcement.pageMarkup && (
                        <div>
                            <Link to={announcementUrl} target="_blank">
                                See Details
                            </Link>
                        </div>
                    )}
                </Stack>
            </Accordion.Body>
        </Accordion.Item>
    );
}
